<template>
  <div id="adminBormacDashboard">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Dashboard</li>
    </ol>
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-people bg-success p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-success">{{usersCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{users}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-chemistry bg-primary p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-primary">{{itemsCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{items}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-settings bg-danger p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-danger">{{itemsNotConfiguredCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{itemsNotConfigured}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-directions bg-warning p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-warning">{{lastSyncDate}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{lastSync}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-6" v-if="configurationsLanguage['Italiano'].title">
          <div class="card">
            <graphic :configurations="configurationsLanguage['Italiano']" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-6" v-if="configurationsLanguage['English'].title">
          <div class="card">
            <graphic :configurations="configurationsLanguage['English']" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-6" v-if="configurationsLanguage['3'].title ">
          <div class="card">
            <graphic :configurations="configurationsLanguage['3']" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-6" v-if="configurationsLanguage['4'].title">
          <div class="card">
            <graphic :configurations="configurationsLanguage['4']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Graphic from "@/components/Graphic.vue";

export default {
  name: "adminBormacDashboard",
  components: {
    Graphic
  },
  data: function() {
    return {
      configurationsLanguage: { Italiano: {}, English: {}, 3: {}, 4: {} },
      items: dictionaryHelpers.getDictionary("Items"),
      itemsCount: 0,
      itemsNotConfigured: dictionaryHelpers.getDictionary("ItemsNotConfigured"),
      itemsNotConfiguredCount: 0,
      lastSync: dictionaryHelpers.getDictionary("LastSync"),
      lastSyncDate: "",
      users: dictionaryHelpers.getDictionary("Users"),
      usersCount: 0
    };
  },
  created() {
    var configurations = this;

    languageServices.all(function(result) {
      $.each(result.data, function(i, language) {
        itemTechnicalSpecificationServices.getCompletedStatByLanguage(
          language.id,
          function(itsResult) {
            if (functionHelpers.isValued(itsResult.data)) {
              configurations.configurationsLanguage[language.description] = {
                title: "Completamento " + language.description,
                idCont: "chart_" + language.id,
                confGrafic: {
                  type: "polarArea",
                  data: itsResult.data,
                  options: {
                    legend: {
                      display: true,
                      position: "bottom"
                    },
                    showLines: true,
                    responsive: true,
                    scale: {
                      ticks: {
                        beginAtZero: true
                      },
                      reverse: false
                    },
                    animation: {
                      animateRotate: false,
                      animateScale: true
                    }
                  }
                }
              };
            }
          }
        );
      });
    });

    userServices.count(function(result) {
      configurations.usersCount = result.data;
    });

    itemServices.count(function(result) {
      configurations.itemsCount = result.data;
    });

    settingServices.getLastSync(function(result) {
      configurations.lastSyncDate = result.message;
    });

    itemGroupTechnicalSpecificationServices.getItemWithoutGroupTechnicalSpecification(
      function(result) {
        configurations.itemsNotConfiguredCount = result.data;
      }
    );
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    }
  }
};
</script>
<style>
canvas {
  /*margin-top: 35px;*/
}
hr {
  border-color: rgba(0, 0, 0, 0);
}
.graphic-card {
  /* background: #ededed; */
  padding: 15px;
  border-radius: 5px;
  /*box-shadow:0px 0px 10px -5px rgba(0,0,0,0.3);*/
}
.graphic-title {
  position: absolute;
}
.graphic-title h6 {
  font-weight: bold;
}
.graphic-title h3 {
  font-size: 20px;
  font-weight: bold;
  color: #b5b5b5;
}
</style>
